import lylloTile from '../images/lyllo_tile.png'
import i18n from 'i18next'
import { operatorC } from '../common/operatorhelpers'


export const themeC = {
    Kung: 'kung',
    Dbet: 'dbet',
    Orange: 'orange',
    OrangeLight: 'orange_light',
    Wood: 'wood',
    Lion: 'lion',
    Video: 'video',
    MrVegas: 'mrvegas',
    Green: 'green',
    ComeOn: 'comeon',
    Hajper: 'hajper',
    Snabbare: 'snabbare',
    Mega: 'mega',
    Lyllo: 'lyllo',
    Stugan: 'stugan',
    Kryss: 'kryss',
    Hard: 'hard',
    GoGo: 'gogo',
    Reviant: 'reviant'
}

export const themeVariantC = {
    Light: 'light',
    Dark: 'dark'
}

// Operators that keep the light Orange look even though they send theme=orange
export const orangeLightOperatorsC = [operatorC.ExpektSe, operatorC.ExpektDk]

// The Danish LeoVegas brands spell the Orange product name in Danish
export const danishProductNameOperatorsC = [operatorC.ExpektDk, operatorC.LeoVegasDk]

const orangeProductName = () =>
    danishProductNameOperatorsC.indexOf(window.operatorId) !== -1 ? "Fodbold" : "Fotboll"

export const gradientsC =
{
    Kung: {
        Max: "linear-gradient(99.41deg, #004CFF 0.2%, #0099C9 99.8%)",
        Mix: "linear-gradient(99.41deg, #700000 0.2%, #6B0DB5 0.21%, #EB00FF 99.8%)",
        Flex: "linear-gradient(99.41deg, #07A85B 0.2%, #06E394 99.8%)"
    },
    Dbet: {
        Max: "linear-gradient(103.87deg, #112F7C 10.41%, #13203C 89.59%)",
        Mix: "linear-gradient(103.87deg, #112F7C 10.41%, #13203C 89.59%)",
        Flex: "linear-gradient(103.87deg, #112F7C 10.41%, #13203C 89.59%)",
    },
    Orange: {
        Max: "linear-gradient(96.02deg, #FE9326 0%, #FE7800 99.7%)",
        Mix: "linear-gradient(96.02deg, #FE9326 0%, #FE7800 99.7%)",
        Flex: "linear-gradient(96.02deg, #FE9326 0%, #FE7800 99.7%)",
    },
    Wood: {
        Max: "linear-gradient(90deg, rgba(30, 30, 30, 0.76) 0%, rgba(30, 30, 30, 0.24) 100%), linear-gradient(180deg, #B19661 0%, #B19661 100%)",
        Mix: "linear-gradient(90deg, rgba(30, 30, 30, 0.76) 0%, rgba(30, 30, 30, 0.24) 100%), linear-gradient(180deg, #B19661 0%, #B19661 100%)",
        Flex: "linear-gradient(90deg, rgba(30, 30, 30, 0.76) 0%, rgba(30, 30, 30, 0.24) 100%), linear-gradient(180deg, #B19661 0%, #B19661 100%)",
    },
    Lion: {
        Max: "linear-gradient(180deg, #EF4701 0%, #FD6301 100%)",
        Mix: "linear-gradient(180deg, #EF4701 0%, #FD6301 100%)",
        Flex: "linear-gradient(180deg, #EF4701 0%, #FD6301 100%)",
    },
    Green: {
        Max: "linear-gradient(96.02deg, #197343 0%, #24995C 99.7%)",
        Mix: "linear-gradient(96.02deg, #197343 0%, #24995C 99.7%)",
        Flex: "linear-gradient(96.02deg, #197343 0%, #24995C 99.7%)",
    },
    ComeOn: {
        Max: "linear-gradient(to right, rgb(41, 47, 42), rgba(57, 245, 106, 0.15))",
        Mix: "linear-gradient(to right, rgb(41, 47, 42), rgba(57, 245, 106, 0.15))",
        Flex: "linear-gradient(to right, rgb(41, 47, 42), rgba(57, 245, 106, 0.15))",
    },
    Hajper: {
        Max: "linear-gradient(to right, rgba(6, 12, 39, 0.6), rgb(13, 25, 79))",
        Mix: "linear-gradient(to right, rgba(6, 12, 39, 0.6), rgb(13, 25, 79))",
        Flex: "linear-gradient(to right, rgba(6, 12, 39, 0.6), rgb(13, 25, 79))",
    },
    Snabbare: {
        Max: "linear-gradient(180deg, #0168FF 0%, #300DAB 100%)",
        Mix: "linear-gradient(180deg, #0168FF 0%, #300DAB 100%)",
        Flex: "linear-gradient(180deg, #0168FF 0%, #300DAB 100%)",
    },
    Reviant: {
        Max: "linear-gradient(180deg, #0168FF 0%, #300DAB 100%)",
        Mix: "linear-gradient(180deg, #0168FF 0%, #300DAB 100%)",
        Flex: "linear-gradient(180deg, #0168FF 0%, #300DAB 100%)",
    },
    Lyllo: {
        Max: `url(${lylloTile})`,
        Mix: `url(${lylloTile})`,
        Flex: `url(${lylloTile})`
    },
    Stugan: {
        Max: "linear-gradient(135deg, #7C0E19 100%, #7C0E19 100%)",
        Mix: "linear-gradient(135deg, #7C0E19 100%, #7C0E19 100%)",
        Flex: "linear-gradient(135deg, #7C0E19 100%, #7C0E19 100%)",
    },
    Kryss: {
        Max: "linear-gradient(135deg, #4f7492 0%, #142346 100%)",
        Mix: "linear-gradient(135deg, #4f7492 0%, #142346 100%)",
        Flex: "linear-gradient(135deg, #4f7492 0%, #142346 100%)",
    },
    Hard: {
        Max: "linear-gradient(135deg, #FACF0C 0%, #FACF0C 100%)",
        Mix: "linear-gradient(135deg, #FACF0C 0%, #FACF0C 100%)",
        Flex: "linear-gradient(135deg, #FACF0C 0%, #FACF0C 100%)",
    },
    GoGo: {
        Max: "linear-gradient(90deg, rgba(37, 37, 37, 0.76) 0%, rgba(37, 37, 37, 0.24) 100%), linear-gradient(180deg, #F14AA7 0%, #F14AA7 100%)",
        Mix: "linear-gradient(90deg, rgba(37, 37, 37, 0.76) 0%, rgba(37, 37, 37, 0.24) 100%), linear-gradient(180deg, #F14AA7 0%, #F14AA7 100%)",
        Flex: "linear-gradient(90deg, rgba(37, 37, 37, 0.76) 0%, rgba(37, 37, 37, 0.24) 100%), linear-gradient(180deg, #F14AA7 0%, #F14AA7 100%)",
    },
}

export const productNamesC =
{
    Kung: {
        Max: "Super",
        Mix: "Super",
        Flex: "Super",
        Winter: "Vinter",
        Hockey: "Hockey"
    },
    Video: {
        Max: "Supertipset",
        Mix: "Supertipset",
        Flex: "Supertipset",
        Winter: "Vinter",
        Hockey: "Hockey"
    },
    Orange: {
        get Max() { return orangeProductName() },
        get Mix() { return orangeProductName() },
        get Flex() { return orangeProductName() },
        Hockey: "Hockey"
    },
    ComeOn: {
        Max: "Max",
        Mix: "Mix",
        Flex: "Flex",
        Hockey: "Hockey"
    },
    Paf: {
        Max: "Max",
        Mix: "Mix",
        Flex: "Flex",
        Hockey: "Hockey"
    },
    Hard: {
        Max: "Pool",
        Mix: "Pool",
        Flex: "Pool",
        Hockey: "Pool"
    },
}

export const howToTextsC =
{
    Dbet: {
        bet_title: "Stora potter och jackpottar.",
        bet_text: "Supertipset har spelare från hela världen. Därför är potterna ofta större.",
        follow_title: "När du vinner, vinner du mer*",
        follow_text: "*Fakta: Supertipset betalar ut 80%. Stryktipset 65%",
        win_title: "Färre smålag, fler storklubbar.",
        win_text: "Spelet du redan kan, med fler toppmatcher!",
    },
    Snabbare: {
        bet_title: "Snabbtipset - Ett enklare 1x2-tips",
        bet_text: "Välj ett eller flera utfall i omgångens matcher och lägg din rad",
        follow_title: "Live-bevakning",
        follow_text: "Följ matcherna och dina vinstchanser i realtid",
        win_title: "Bra utdelning",
        win_text: "80 % av insatserna går till vinst – sätter du raden kan det bli full pott!",
    },
    Reviant: {
        bet_title: "Revianttipset - Ett enklare 1x2-tips",
        bet_text: "Välj ett eller flera utfall i omgångens matcher och lägg din rad",
        follow_title: "Live-bevakning",
        follow_text: "Följ matcherna och dina vinstchanser i realtid",
        win_title: "Bra utdelning",
        win_text: "80 % av insatserna går till vinst – sätter du raden kan det bli full pott!",
    },
    Lyllo: {
        bet_title: "Tippa enkelt – vinn stort!",
        bet_text: "Välj ett eller flera utfall i omgångens matcher",
        follow_title: "Följ spänningen live",
        follow_text: "Se hur matcherna utvecklas i realtid och håll koll på dina vinstchanser",
        win_title: "RIKTIGT BRA UTDELNING",
        win_text: "80 % av insatserna delas ut i vinster – träffar du rätt, delar du potten!",
    },
    Stugan: {
        bet_title: "Tippa 1x2 – Lägg din rad!",
        bet_text: "Välj utfall i omgångens matcher och lägg din rad",
        follow_title: "Live-bevakning",
        follow_text: "Följ matcherna och se hur din rad presterar i realtid",
        win_title: "Vinn potten",
        win_text: "80 % av insatserna går till vinst – sätter du raden kan det bli full pott!",
    },
    Hajper: {
        bet_title: "Tippa",
        bet_text: "Välj 1x2 i omgångens matcher",
        follow_title: "Live-bevakning",
        follow_text: "Följ dina resultat i realtid",
        win_title: "Vinn",
        win_text: "Sätter du 13, 12 eller 8 matcher delar du på vinstpotten"
    },
    Hard: {
        bet_title: "Visa vad du kan",
        bet_text: "Välj utfallet i omgångens matcher och bygg ditt spel precis som du vill.",
        follow_title: "Känn pulsen",
        follow_text: "Följ matcherna och dina vinstchanser live.",
        win_title: "Casha in",
        win_text: "Får du tillräckligt många rätt? 80% av alla insatser går direkt tillbaka till vinnande spelare.",
    },
}

export const GetMixMaxFlex = (roundName: string, theme: string) => {

    if (!IsVideo(theme)) {
        return roundName;
    }

    if (roundName.indexOf("Winter") > -1) {
        return productNamesC.Kung.Winter;
    }

    if (roundName.indexOf("Hockey") > -1) {
        return productNamesC.Kung.Hockey;
    }

    if (theme === themeC.Kung || theme === themeC.Dbet) {
        if (roundName.indexOf("Max") > -1) {
            return productNamesC.Kung.Max;
        }
        if (roundName.indexOf("Mix") > -1) {
            return productNamesC.Kung.Mix;
        }
        if (roundName.indexOf("Flex") > -1) {
            return productNamesC.Kung.Flex;
        }
    }

    if (roundName.indexOf("Max") > -1) {
        return productNamesC.Video.Max;
    }
    if (roundName.indexOf("Mix") > -1) {
        return productNamesC.Video.Mix;
    }
    if (roundName.indexOf("Flex") > -1) {
        return productNamesC.Video.Flex;
    }

    return roundName;
}

export const GetFlexNumber = (roundName: string) => {

    if (roundName.indexOf("Hockey7") > -1) {
        return "7";
    }
    if (roundName.indexOf("Hockey9") > -1) {
        return "9";
    }
    if (roundName.indexOf("Survivor6") > -1 || roundName.indexOf("Flextipset6") > -1) {
        return "6";
    }

    return "8";
}

export const IsShareCouponEnabled = (theme: string) => {

    if (theme === themeC.Dbet ||
        theme === themeC.Orange ||
        theme === themeC.GoGo ||
        theme === themeC.Wood ||
        theme === themeC.Lion ||
        theme === themeC.Lyllo ||
        theme === themeC.Stugan ||
        theme === themeC.Snabbare ||
        theme === themeC.ComeOn ||
        theme === themeC.Hajper ||
        theme === themeC.Reviant ||
        theme === themeC.Green) {
        return true;
    }
}

export const IsLeo = (theme: string) => {

    return (theme === themeC.Orange ||
        theme === themeC.Wood ||
        theme === themeC.Lion ||
        theme === themeC.Green ||
        theme === themeC.GoGo ||
        IsComeOn(theme) ||
        IsPaf(theme) ||
        theme === themeC.Hard
    );

}

export const IsComeOn = (theme: string) => {

    return (
        theme === themeC.ComeOn ||
        theme === themeC.Hajper ||
        theme === themeC.Snabbare ||
        theme === themeC.Lyllo ||
        theme === themeC.Stugan ||
        theme === themeC.Reviant
    );
}

export const IsOrangeLight = (theme: string) => {

    return theme === themeC.Orange && window.themeVariant === themeVariantC.Light;
}

export const IsOrangeDark = (theme: string) => {

    return theme === themeC.Orange && window.themeVariant !== themeVariantC.Light;
}

export interface CashoutThemeColors {
    cashOutBg: string;
    cashOutText: string;
}

// Branch order matches getSurvivorThemeColors, which these values were lifted from.
export const getCashoutThemeColors = (theme: string): CashoutThemeColors => {
    if (theme === themeC.Snabbare) return { cashOutBg: '#234BFF', cashOutText: '#FFFFFF' };
    if (theme === themeC.Stugan) return { cashOutBg: '#7C0E19', cashOutText: '#FFFFFF' };
    if (theme === themeC.Dbet) return { cashOutBg: '#112F7C', cashOutText: '#FFFFFF' };
    if (theme === themeC.Lyllo) return { cashOutBg: '#F02884', cashOutText: '#FFFFFF' };
    if (theme === themeC.Kryss) return { cashOutBg: '#1191D7', cashOutText: '#FFFFFF' };
    if (theme === themeC.Green) return { cashOutBg: '#147B45', cashOutText: '#FFFFFF' };
    if (theme === themeC.Lion) return { cashOutBg: '#008844', cashOutText: '#FFFFFF' };
    if (IsOrangeLight(theme)) return { cashOutBg: '#25852F', cashOutText: '#FFFFFF' };
    if (theme === themeC.Orange) return { cashOutBg: '#25852F', cashOutText: '#FFFFFF' };
    if (theme === themeC.Wood) return { cashOutBg: '#B19661', cashOutText: '#0C0C0C' };
    if (theme === themeC.Hajper) return { cashOutBg: '#A9F7CA', cashOutText: '#060C27' };
    return { cashOutBg: '#00E68F', cashOutText: '#0C0C0C' };
}

export const IsPaf = (theme: string) => {

    return (
        theme === themeC.Kryss
    );
}


export const IsVideo = (theme: string) => {

    return (theme === themeC.Kung ||
        theme === themeC.Dbet ||
        theme === themeC.Video ||
        theme === themeC.MrVegas ||
        theme === themeC.Mega
    );

}

export const GetJackpotString = (theme: string, t: any, isRealJackpot: boolean = false, fixtureCount?: number) => {
    const isKryssSv = theme === themeC.Kryss && i18n.language === 'sv' && fixtureCount;

    if (isRealJackpot) {
        if (isKryssSv) return `${fixtureCount}-rättspott`;
        if (theme === themeC.Snabbare || theme === themeC.Stugan || theme === themeC.Reviant) return t('real_jackpot_alt');
        return t('real_jackpot');
    }
    if (isKryssSv) return `Uppskattad ${fixtureCount}-rättspott`;
    if (theme === themeC.Snabbare || theme === themeC.Stugan || theme === themeC.Reviant) return t('jackpot_alt');
    return t('jackpot');
}

export const UsePoolXLogoInRoundList = (theme: string) => {
    if (IsLeo(theme) || IsVideo(theme))
        return false;
    return true
}

export const GetProPickLabel = (theme: string, t: any) => {
    if (theme === themeC.Green) return "Auto Picks";
    return t('pro_pick');
}

export const GetProPickBetsLabel = (theme: string, t: any) => {
    if (theme === themeC.Green) return "Auto Picks";
    return t('pro_pick_bets');
}

//Right to left theme (Ex. Arabic and Farsi)
export const IsRightToLeftTheme = (theme: string) => {
    return false
}

export function getTheme(urlSearchParams: URLSearchParams, languageSetTo: string, operatorId: string) {

    let pTheme = urlSearchParams.get('theme');

    if (pTheme === undefined || pTheme === null || pTheme === "") {
        pTheme = themeC.Green;
    }

    // orange_light is a variant of orange, not a theme of its own
    if (pTheme === themeC.OrangeLight) {
        pTheme = themeC.Orange;
    }

    return pTheme;
}

export function getThemeVariant(urlSearchParams: URLSearchParams, operatorId: string) {

    const pTheme = urlSearchParams.get('theme');
    const pThemeMode = urlSearchParams.get('themeMode');

    // Skins without variants ignore themeMode and render as before
    if (pTheme === themeC.Orange && (pThemeMode === themeVariantC.Light || pThemeMode === themeVariantC.Dark)) {
        return pThemeMode;
    }

    if (pTheme === themeC.OrangeLight) {
        return themeVariantC.Light;
    }

    if (pTheme === themeC.Orange && orangeLightOperatorsC.indexOf(operatorId) > -1) {
        return themeVariantC.Light;
    }

    return themeVariantC.Dark;
}

